import React, { MouseEvent, FocusEvent, createRef } from 'react'

import { isEmpty } from '../../validation/stringRegex'

import { getSvgError } from '../icons/svg'

import { authFetch } from '../../cookie/Cookie'

import { BaseComponent, BaseProps, BaseState } from '../BaseComponent'

import { BaseEnumType } from '../../initialization/remoteInits'


interface InputProps extends BaseProps {
    value: string | undefined      // il valore
    choices: any[]                 // le possibili scelte
    updateChoicesUrl?: string | undefined  // l'eventuale URL di ricecrca con cui aggiornare le scelte
    getRequstBody?: Function,
    expiredSessionCallbak?: Function
    error?: string | undefined
    clearError?: Function

    refInput?: React.RefObject<HTMLInputElement> | undefined
    
}

interface InputState extends BaseState {
    partialValue: string | undefined
    selectedId: string | undefined
    matches: any[]
    hasFocus: boolean
    isDeleteAction: boolean
}

/**
 * gli attributi sicuramente gestiti -- quelli da non riscrivere
 */
const defaults : InputProps = {
    value: undefined,
    choices: [],
    id: undefined,
    className: 'form-control-lg',
    type:'text',
    updateChoicesUrl: undefined,
    getRequstBody: undefined,
    onFocus: undefined,
    onBlur: undefined,
    onChange: undefined,
    callback: undefined,
    expiredSessionCallbak: undefined,
    error: undefined,
    clearError: undefined,
    errorDisplayMsg: undefined,
    refInput: undefined
}

/**
 * Component "input testuale" che pesca i possibili valori da un array di scelte
 */
class AutoCompleteInput extends BaseComponent<InputProps, InputState> {
    private stepInput: React.RefObject<HTMLInputElement>
    private timeOut: ReturnType<typeof setTimeout> | undefined

    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props} as InputProps

        let errors = undefined

        if (this.notEmpty(this.props.error)) {
            errors = this.props.error
        }
        
        const selectedId = (this.props.choices !== undefined && this.props.choices.findIndex)
                    ? this.props.choices.findIndex( e => e.id === this.props.value )
                    : -1
        const calcSelectId = (selectedId === -1) ? undefined : 'downshift-' + this.props.id + '-suggestion-' + selectedId

        this.state = {
            hasFocus: false,
            partialValue: (selectedId === -1 || selectedId === undefined) 
                ? this.props.value                          // autocompletamento da remoto
                : this.props.choices[selectedId].value,     // autocompletamento da lista locale
            selectedId: calcSelectId,
            matches: [],
            validationError: errors,
            isDeleteAction: false
        }

        this.getLAutoCompleteabel = this.getLAutoCompleteabel.bind(this)
        this.printAutoCompliteInput = this.printAutoCompliteInput.bind(this)
        this.updatePartialValue = this.updatePartialValue.bind(this)
        this.getMatches = this.getMatches.bind(this)
        this.getRemoteChoice = this.getRemoteChoice.bind(this)
        this.selectValue = this.selectValue.bind(this)
        this.onEdit = this.onEdit.bind(this)
        this.onFocuskHandler = this.onFocuskHandler.bind(this)

        this.stepInput = (this.props.refInput === undefined) ? createRef() : this.props.refInput
        this.timeOut = undefined
    }

    componentDidUpdate(prevProps: Readonly<InputProps>, prevState: Readonly<InputState>, snapshot?: any): void {
        // evito la perdita del focus quando rimuovo lo span di errore
        if (
            prevProps.error !== undefined &&  prevProps.error !== '' &&
            (this.props.error === undefined || this.props.error === '') &&
            document.activeElement?.id !== this.stepInput.current?.id
        ) {
            // se prima avevo un errore e ora no --> lo span di errore non viene più disegnato
            // quindi il component fa un re - render --> quindi rido il focus
            this.stepInput.current?.focus()
        }
    }

    render () {
        const attributes = this.getPropertyDifferences (this.mergedProps ?? {}, defaults)

        const labelTag = this.getLAutoCompleteabel()
        const errorTag = this.getTextError()

        const classString = 
            (this.props.value !== undefined && errorTag === undefined ? 'is-ok ' : '') +
            (this.state.hasFocus ? 'focus ' : '') +
            (
                (this.props.className ?? '') === 'form-control-lg' 
                    ? this.props.className + ' form-control-lg'
                    : 'form-control-lg' 
            ) + 
            (errorTag !== undefined ? ' is-invalid' : '')

        return (
            this.props.id &&
                <div className='col-12 downshift-container'>
                    {labelTag !== undefined && labelTag}

                    {
                        errorTag !== undefined
                        ?   <div className='input-group'>
                                {this.printAutoCompliteInput( classString, attributes )}

                                <span className="input-group-text">
                                    {errorTag}
                                </span>
                            </div>
                        :   this.printAutoCompliteInput( classString, attributes )
                    }
                </div>
        )
    }

    private getLAutoCompleteabel () {
        const hasError = (this.props.error ?? this.state?.validationError)
        const labelClass =  (hasError !== undefined) ? 'is-invalid form-label' : 'form-label'

        return ( this.props.label && this.props.id )
            ?   <label 
                    id={'downshift-' + this.props.id + '-label'}
                    className={labelClass}
                    htmlFor={`${this.props.id}`}
                >
                    {hasError && getSvgError()}
                    {this.props.label}
                </label>
            :   undefined
    }

    private printAutoCompliteInput (classString: string, attributes: any) {
        const DROP_ID = 'downshift-' + this.props.id
        const LABEL_ID = DROP_ID + '-label'
        const UL_ID = DROP_ID + '-menu'
        const LI_PARTIAL_ID = DROP_ID + '-suggestion-'

        const suggestionClassName = (this.state.matches !== undefined && this.state.matches.length > 0)
            ? 'downshift-suggestion'
            : 'hidden'

        return (
            <>
                <input
                    id={this.props.id}
                    role='combobox'
                    value={this.state.partialValue ?? ''}

                    className={classString}

                    type='search'
                    inputMode='search'

                    autoComplete='off'
                    autoFocus={false}

                    placeholder='Inizia a digitare'

                    aria-activedescendant={this.state.selectedId}
                    aria-label='Inizia a digitare'
                    aria-autocomplete='list'
                    aria-controls={UL_ID}
                    aria-labelledby={LABEL_ID}
                    aria-expanded={this.state.matches.length > 0}

                    onFocus={this.onFocuskHandler}
                    onChange={this.updatePartialValue}
                    onKeyDown={this.onEdit}
                    onInput={(e) => e.currentTarget.value = (e.currentTarget.value ?? '').toUpperCase()}

                    ref={this.stepInput}

                    {...attributes}
                />
                <div className={suggestionClassName}>
                    <ul 
                        id={UL_ID}

                        className='form-control-lg  downshift-ul'

                        role='listbox'
                        aria-label='Suggerimenti per auto completamento'
                        aria-labelledby={LABEL_ID}
                    >
                        { this.state.matches.length > 0 &&
                            <>
                                {this.state.matches.map ((suggestion, index) => {
                                    const id = LI_PARTIAL_ID + index
                                    return (
                                        <li
                                            key={id}
                                            id={id}
                                            aria-selected={
                                                LI_PARTIAL_ID + index === this.state.selectedId
                                            }
                                            data-suggestion={suggestion.value}
                                            data-value={suggestion.id}
                                            onClick={this.selectValue}
                                        >
                                            {suggestion.value}
                                        </li>
                                    )
                                })}
                            </>
                        }
                    </ul>
                </div>
            </>
        )
    }

    private onEdit (e: KeyboardEvent) {
        if (this.timeOut) {
            clearTimeout(this.timeOut) // fiche digito pulisco il times
        }

        this.setState ({
            isDeleteAction: (e.key === 'Delete' || e.key === 'Backspace')
        })
    }

    private updatePartialValue (e: MouseEvent<HTMLInputElement>) {
        let val: string | undefined = e.currentTarget.value

        const next: any = {
            partialValue: val ?? '',
            matches: []
        }

        this.setState ( 
            next, 
            () => {
                if (!isEmpty(val)) {
                    
                    this.timeOut = setTimeout( () => {
                        this.getMatches( val ).then ( (match) => {
                            
                            if (match === undefined) {
                                match = []
                            }

                            if (match.length === 1  && !(this.state.isDeleteAction)) {	
                                // ho trovato! -- stop
                                const nextId = match[0]?.id
                                
                                next.partialValue = (isNaN(nextId)) ? match[0]?.id : match[0]?.value
                                next.matches = []
                                this.stepInput.current?.blur()
                            }
                            else {
                                // non ho trovato mostro
                                delete next.value
                                next.matches = match
                            }

                            this.setState ( 
                                next,
                                () => {
                                    if (this.props.callback && (match && match.length === 1)) {
                                        this.props.callback( match[0].id )
                                    }
                                }
                            )
                        })
                    }, 300)

                }
                else if ( this.props.callback ) {
                    this.props.callback( undefined )
                }
            }
        )
    }

    /**
     * Ritorna l'array di possibili match
     * @param search il termine da cercare
     * @returns un array
     */
    private async getMatches (search: string | undefined) {
        if (search === undefined || search === '') {
            // nulla da cercare
            return new Promise<any[]> ( (resolve) => {
                resolve( [] )
            })
        }
        
        if (
            search.length <= 2 || 
            this.props.updateChoicesUrl === undefined  ||
            this.props.getRequstBody === undefined
        ) {
            // cerco da un array noto
            return new Promise<any[]> ( (resolve) => {
                resolve( 
                    this.props.choices.filter (
                        c => c.value.startsWith( search )
                    )
                 )
            })
        }
        else {
            return await this.getRemoteChoice(search).then( res => {
                return res.filter (
                    (c: BaseEnumType) => c.id.startsWith( search )
                )
            })
        }
    }

    /**
     * Chiama il microservizio per cercare il valore
     * @param search il valore da cercare
     * @returns una promesa con il risultato
     */
    private async getRemoteChoice (search : string) {
        const url = (this.props.updateChoicesUrl)
            ? this.props.updateChoicesUrl
            : '#'
        
        const expSessionFunction = (this.props.expiredSessionCallbak)
            ? this.props.expiredSessionCallbak
            : () => {}

        const requestBody = (this.props.getRequstBody !== undefined) 
            ? this.props.getRequstBody(search) 
            : {}

        return await authFetch (
            url,
            {
                method: 'post',
                body: JSON.stringify( requestBody )
            },
            expSessionFunction
        )
        .then( (res: any) => {
            // res = [{"id":"Nuoro (NU)","value":"Nuoro (NU)"}]
            return res
        })
        .catch( async (err) => {
            return []
        })
    }
    
    /**
     * Gestisce il click sulle possibili opzoni
     * @param e l'evento del click
     */
    private selectValue (e: MouseEvent<HTMLLIElement>) {
        e.stopPropagation()
        e.preventDefault()

        this.stepInput.current?.focus()

        let val = e.currentTarget.getAttribute('data-value')

        let textValue = e.currentTarget.textContent
        /*
        if (!isNaN( Number(val) ) ) {
            // se è un ID numerico --> voglio una stringa
            val = e.currentTarget.textContent
        }
        */

        this.setState({
            partialValue: textValue || undefined,
            matches: []
        }, () => {
            if (this.props.callback) {
                this.props.callback( val )
            }
        })
    }

    private onFocuskHandler (e: FocusEvent<HTMLInputElement>) {
        e.stopPropagation()

        this.setState(
            {
                hasFocus: true,
                validationError: undefined
            },
            () => {
                if (this.props.onFocus) {
                    this.props.onFocus(e)
                }
            }
        )
    }
}

export default AutoCompleteInput